module.exports = __webpack_public_path__ + "static/media/User.3a1c5796.svg";